<template>
    <div class="row reports-monthly-summary">
        <div class="col">
            <div class="row">
                <div class="col">
                    <table-resume
                        :title="title"
                        :route="route"
                        :externalFilters="filters"
                        :extraQueryParams="extraQueryParams"
                        :autoUpdateExternalFilter="autoUpdateExternalFilter"
                        :autoUpdateFilter="true"
                        :showTitleData="false"
                        titleClass="subtitle"
                        :settings="settings"
                        :columns="columns"
                        :loadingMsg="loadingMsg"
                        :notFoundMsg="notFoundMsg"
                        :orderByTemplate="orderByTemplate"
                        :allowExportData="allowExportData"
                        :confirmExportData="false"
                        :titleExportData="titleExportData"
                        :confirmMsgExportData="confirmMsgExportData"
                        :errorMsgExportData="errorMsgExportData"
                        :showPagination="false"
                        :tableWrapperClass="tableWrapperClass+ ' bg-lilac-light'"
                        :tableClass="tableClass"
                        :funcExportData="onExport"
                    >
                        <template v-slot:body="{row, index}">
                            <td>{{ row.year }}</td>
                            <td>{{ row.month }}</td>
                            <td v-for="(column, idx) in columns" v-if="column.id">
                                {{ getValueFromItem(row.states, column, prop='total') }}
                            </td>
                        </template>
                    </table-resume>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {HasLoadingState, HasReport} from './mixins/index';

    export default {
        name: 'reportMonthlySummary',
        mixins: [
            HasLoadingState,
            HasReport
        ],
        components: {
            TableResume: () => import(/* webpackChunkName: "data-table" */ '@/app/shared/components/tables/DataTable'),
        },
        props: {
            tableClass: {
                type: String,
                default: 'table-responsive-sm'
            },
            tableWrapperClass: {
                type: String,
                default: ''
            },
            autoUpdateExternalFilter: {
                type: Boolean,
                default: false
            },
            states: {
                type: Array,
                required: true,
            },
            columns: {
                type: Array,
                default: () => {
                    return [{
                        label: 'Ano',
                    },{
                        label: 'Mês',
                    }]
                },
            }
        },
        data() {
            return {
            }
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    @import "@styles/_mixins.scss";
    @import "@styles/_theme.scss";
    .reports-monthly-summary {
        td {
            white-space: nowrap;
        }
    }
</style>